var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlphaInsurance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.6038 54.2847C52.1456 55.0298 50.4807 49.9086 49.0159 43.9499C47.9555 39.6371 46.7519 34.2048 46.2102 31.5872C49.6377 24.2284 53.6108 15.3926 59.5261 2.33053H48.458C46.4901 6.64479 44.5464 11.0135 42.6228 15.2864C42.0734 13.1357 41.3165 10.8202 40.4373 8.8518C37.8901 3.33351 33.8842 -0.465069 27.9139 0.0460116C20.0217 0.722081 14.0599 6.01016 9.24773 12.7386C4.83508 18.9073 0.531378 27.9176 0.0418152 38.1231C-0.613221 51.7849 6.52495 59.61 14.6173 60.4683C21.0123 61.1471 25.8012 58.7701 29.8318 55.8206C32.5678 53.8189 38.3896 47.0363 40.1319 44.0124C41.4249 52.3958 44.7619 60.4296 52.2787 60.4296C56.9375 60.4296 59.8883 56.8535 61.475 54.0902C60.9053 54.1515 60.2863 54.216 59.6035 54.2843L59.6038 54.2847ZM23.695 49.2069C21.9687 50.9558 19.7544 52.8136 17.4301 53.3185C11.65 54.5732 9.10091 48.2987 9.50321 39.9107C9.81715 33.3618 11.6752 27.2948 13.85 22.0344C16.0794 16.6423 18.6822 11.8646 21.6495 8.98494C22.7088 7.95549 24.3004 6.72959 26.5078 6.48172C31.82 5.88546 33.775 13.9216 35.1265 20.6554C35.7576 23.8155 36.1827 27.0301 36.3877 28.7207C34.8729 31.8297 30.1708 42.6465 23.695 49.2069Z",
    fill: "#E94E09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphaInsurance);
export default __webpack_public_path__ + "static/media/alpha_insurance.7f7c2cb32943a33037ba6af34da57ae0.svg";
export { ForwardRef as ReactComponent };